// extracted by mini-css-extract-plugin
export var contactWrapper = "Footer-module--contactWrapper--PdWXs";
export var disclaimer = "Footer-module--disclaimer--uShHB";
export var root = "Footer-module--root--k6EnZ";
export var socialmediaWrapper = "Footer-module--socialmediaWrapper--IKnRM";
export var withSidebar = "Footer-module--withSidebar--2h+gL";